// This is your plugin object. It can be exported to be used anywhere.
const articleUrl = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    Vue.prototype.$articleUrl = (id, title, pageid, region) => {
      let articleRoute = {}
      title = encodeURI(title.replace(/[^\w\s]/gi, '').replace(/[\s]/gi, "-").toLowerCase())

      if (region === null) {
        articleRoute.name= 'artikel',
        articleRoute.params= {
          'title': title,
          'id': id,
          'pid': pageid
        }
      } else {
        articleRoute.name= 'artikelbezirke',
        articleRoute.params= {
          'region': region,
          'title': title,
          'id': id,
          'pid': pageid
        }
      }

      // console.log('articleRoute: ', articleRoute)

      return articleRoute
    }
  }
}

// Usage example:
// {{ $articleUrl(article.id, article.title, pageid, region) }}
export default articleUrl



// WEBPACK FOOTER //
// ./src/plugins/articleUrl.js